import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface GradeDetailState {
    id: number;
    name: string;
    en_name: string;
    code: string;
    level_code: string;
    status: 0 | 1;
    created_date: string;
    updated_date: string;
}

interface GradeData {
    gradeList: GradeDetailState[];
}

const initialState: any = {
    gradeList: [],
    gradeCreation: {},
    loading: false,
    success: false,
    gradeModuleList: [],
    gradeModuleListLoading: false,
    addGradeModuleLoading: false,
    removeGradeModuleLoading: false,
    moduleAvailableList: [],
};

const gradeSlice = createSlice({
    name: 'grade',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setSuccess(state, action) {
            state.success = action.payload;
        },
        setGradeList(state, action) {
            state.gradeList = action.payload;
        },
        setGradeCreation(state, action) {
            state.gradeCreation = action.payload;
        },
        clearGradeData(state) {
            state.gradeList = [];
            state.gradeCreation = {}
        },
        setGradeModuleList(state, action) {
            state.gradeModuleList = action.payload;
        },
        setGradeModuleListLoading(state, action) {
            state.gradeModuleListLoading = action.payload;
        },
        clearGradeModuleData(state) {
            state.gradeModuleList = [];
        },
        setAddGradeModuleLoading(state, action) {
            state.addGradeModuleLoading = action.payload;
        },
        setRemoveGradeModuleLoading(state, action) {
            state.removeGradeModuleLoading = action.payload;
        },
        setModuleAvailableList(state, action) {
            state.moduleAvailableList = action.payload;
        }
    },
});

export const {
    setLoading,
    setSuccess,
    setGradeList,
    setGradeCreation,
    clearGradeData,
    setGradeModuleList,
    setGradeModuleListLoading,
    clearGradeModuleData,
    setAddGradeModuleLoading,
    setRemoveGradeModuleLoading,
    setModuleAvailableList
} = gradeSlice.actions;

export default gradeSlice.reducer;
